import React, { useEffect } from "react";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import Valuation from "../common/valuation/Valuation";
import TradeInAemVehicleResultBlock from "../common/TradeInAemVehicleResultBlock";
import TradeInAemSummaryDealerBlock from "./TradeInAemSummaryDealerBlock";
import TradeInAemSummaryModelBlock from "./TradeInAemSummaryModelBlock";
import TradeInAemSummaryContactBlock from "./TradeInAemSummaryContactBlock";
import * as Styles from "../common/styles/TradeInAem";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { TradeInAemContactFormId, TradeInAemNavStep } from "../../../utils/constants";
import { TradeInAemLabel } from "../../../utils/labels";
import { trackStepSummary } from "../../../utils/tracking";
import { setTradeInSetShowInModal } from "../../../redux/actions/TradeInAemUtilsActions";
import TradeInAemSummaryDisclaimers from "./TradeInAemSummaryDisclaimers";
import ButtonPrimary from "../../../../common-deprecated/components/aem/toyota/ButtonPrimary";
import ButtonTertiary from "../../../../common-deprecated/components/aem/toyota/ButtonTertiary";
import useTradeInPdf from "../../../hooks/useTradeInPdf";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { useDispatch } from "../../../../shared-logic/redux/store";
import { sha256 } from "../../../../shared-logic/utils/commonUtils";

const TradeInAemSummaryContainer = (): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const csl = useTradeInCsl();
    const backToWebsiteUrl = useTradeInAemSelector((state) => state.tradeInAemSettings.backToWebsiteUrl);
    const tradeInAemModelSelect = useTradeInAemSelector((state) => state.tradeInAemModelSelect);
    const showStandaloneModal = useTradeInAemSelector((state) => state.tradeInAemUtils.showStandaloneModal);
    const emailAddress = useTradeInAemSelector(
        (state) => state.tradeInAemContact[TradeInAemContactFormId.Email]?.value || "",
    );

    const { showPdfButton, onPrint } = useTradeInPdf();
    const trackingParams = useTrackingParams();

    useEffect(() => {
        const trackWithHashedEmail = async (): Promise<void> => {
            // The email address is hashed before we send the tracking event (UC-1248)
            const hashedEmailAddress = await sha256(emailAddress);
            trackStepSummary(trackingParams, tradeInAemModelSelect, hashedEmailAddress);
        };

        trackWithHashedEmail();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Styles.Main>
            <Styles.Container>
                {!csl.hideValuationValueOnSummary && <Valuation />}
                <TradeInAemVehicleResultBlock />
                {csl.enabledNavSteps.includes(TradeInAemNavStep.ModelSelect) && (
                    <Styles.BuyingIntention>
                        <TradeInAemSummaryModelBlock />
                    </Styles.BuyingIntention>
                )}
                {csl.enabledNavSteps.includes(TradeInAemNavStep.ContactForm) && <TradeInAemSummaryContactBlock />}
                {csl.enabledNavSteps.includes(TradeInAemNavStep.DealerFinder) && <TradeInAemSummaryDealerBlock />}
                <Styles.Actions spaceBetween={showPdfButton}>
                    {showPdfButton && (
                        <ButtonTertiary hasIcon onClick={onPrint}>
                            <Icon variant="download" />
                            <Text.Button>
                                <TradeInAemLabel label="tradeInAemDownloadPdf" />
                            </Text.Button>
                        </ButtonTertiary>
                    )}
                    <ButtonPrimary
                        // If the component is rendered in a modal, hide it when clicking the back button.
                        // Use the website url if the component is embedded in a page.
                        href={!showStandaloneModal ? backToWebsiteUrl : "#"}
                        onClick={
                            showStandaloneModal
                                ? () => {
                                      dispatch(setTradeInSetShowInModal(false));
                                  }
                                : undefined
                        }
                    >
                        <TradeInAemLabel label="tradeInAemBackToWebsite" />
                    </ButtonPrimary>
                </Styles.Actions>
                <TradeInAemSummaryDisclaimers />
            </Styles.Container>
        </Styles.Main>
    );
};
export default TradeInAemSummaryContainer;
